import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VueStore from "@/store/VueStore";
import initialState from "@/store/initial_state";
import LanguageSettingConfig from "@/language/language_config"

import { Auth } from "aws-amplify";
import { CognitoUser } from "amazon-cognito-identity-js";
import router from "../../router";

@Component({})
export default class SignIn extends Vue {
  public user: string = "";
  public password: string = "";
  public loginForm: boolean = false;
  public signInButton: boolean = true;
  public signInLoadButton: boolean = false;
  public error: string = "";
  public selectedLanguage: string = this.$root.$i18n.locale;
  public languageChoices: Array<{[key: string]: string}> = LanguageSettingConfig.languageChoices()

  public created() {
    this.auth();
    this.$parent.$children[0].$data.headerElement = false;
    localStorage.setItem("initialState", JSON.stringify(initialState));
  }

  public auth() {
    this.loginForm = true;
  }

  public signIn() {
    const self = this;
    self.signInButton = false;
    self.signInLoadButton = true;
    self.getToken(self.user, self.password);
  }

  public signUp() {
    localStorage.clear();
    return router.push("/signUp");
  }

  public reminder() {
    localStorage.clear();
    return router.push("/reminder");
  }

  public checkSignInError(err: string) {
    const self = this;
    switch (err) {
      case "UserNotFoundException":
        self.error = this.$t("message.userDoesNotExist") as string;
        return;
      case "NotAuthorizedException":
        self.error = this.$t("message.idOrPasswordIsIncorrect") as string;
        return;
      default:
        self.error = this.$t("message.failedToLogin") as string ;
        return;
    }
  }

  public getToken(userName: string, password: string) {
    const self = this;

    Auth.signIn(userName, password).then((user: CognitoUser) => {
      const userSession = user.getSignInUserSession();
      // Token取得
      const token = userSession.getIdToken().getJwtToken();
      const graphSettings = userSession.getIdToken().decodePayload()[
        "custom:graphSettings"
      ];
      const expTime = userSession.getIdToken().decodePayload().exp;
      const mailadress: string = userSession.getIdToken().decodePayload().email;
      const iotKyotoAuth = {
        userName,
        graphSettings,
        limitTime: moment()
          .add(12, "h")
          .format(),
        mailadress,
      };
      const targetPath: string =
        localStorage.getItem("path") === null
          ? "/"
          : localStorage.getItem("path");
      localStorage.setItem("iotKyotoAuth", JSON.stringify(iotKyotoAuth));
      localStorage.setItem("graphSettings", graphSettings);
      localStorage.setItem(
        "limitTime",
        moment()
          .add(12, "h")
          .format(),
      );
      VueStore.commit("setUser", userName);
      VueStore.commit("setToken", token);
      VueStore.commit("setExpTime", expTime);
      self.error = "";
      const headerComponent = self.$parent.$children[0];
      const useSignal: boolean =
        typeof JSON.parse(graphSettings).useSignal === "undefined"
          ? false
          : JSON.parse(graphSettings).useSignal;
      const usePresence: boolean =
        typeof JSON.parse(graphSettings).usePresence === "undefined"
          ? false
          : JSON.parse(graphSettings).usePresence;
      const useTimeZone: string =
        typeof JSON.parse(graphSettings).useTimeZone === "undefined"
          ? "+09:00"
          : JSON.parse(graphSettings).useTimeZone;
      const userIsSpread: string =
      typeof JSON.parse(graphSettings).userIsSpread === "undefined"
        ? false
        : JSON.parse(graphSettings).userIsSpread;
      VueStore.commit("setUseSignal", useSignal);
      VueStore.commit("setUsePresence", usePresence);
      VueStore.commit("setUseTimeZone", useTimeZone);
      VueStore.commit("setUserIsSpread", userIsSpread);
      headerComponent.$data.useSignal = useSignal;
      headerComponent.$data.timeZone = useTimeZone;
      headerComponent.$data.userIsSpread = userIsSpread;

      return router.push(targetPath);
    }).catch((err: any) => {
      console.error(err);
      self.checkSignInError(err.code);
      self.user = "";
      self.password = "";
      self.signInButton = true;
      self.signInLoadButton = false;
    });
  }
  public switchLanguage() {
    LanguageSettingConfig.saveLanguageSettingToStorages(this.selectedLanguage);
    location.reload();
  }
}
